import { bypassHtmlCacheRegex } from '@ms/yammer-web-support/dist/pwa/routes';
import type { SWSyncMessageType } from '@ms/yammer-web-support/dist/pwa/serviceWorkerSync';

const syncDelayMs = 5000;
let pendingSyncTimeout: ReturnType<typeof setTimeout> | undefined;

export const cancelPendingCacheSync = (): void => {
  if (pendingSyncTimeout) {
    clearTimeout(pendingSyncTimeout);
    pendingSyncTimeout = undefined;
  }
};

export const triggerCacheSync = (): void => {
  if (bypassHtmlCacheRegex.test(window.location.search)) {
    return;
  }

  cancelPendingCacheSync();
  pendingSyncTimeout = setTimeout(() => {
    const scriptVer = document.querySelector('meta[name="scriptVer"]')?.getAttribute('content');
    if (scriptVer) {
      const message: { readonly type: SWSyncMessageType; readonly scriptVer: string } = {
        type: 'PRECACHE_LATEST_RELEASE_ASSETS_AFTER_DELAY',
        scriptVer,
      };
      navigator.serviceWorker.controller?.postMessage(message);
    }
    pendingSyncTimeout = undefined;
  }, syncDelayMs);
};
